import React from 'react';
import { instituteMock } from '../data/mock';

const Footer = () => {
  const { footer, name } = instituteMock;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img 
              src="/logo-retina-viva.png" 
              alt="Instituto Retina Viva" 
              className="footer-logo-img"
            />
          </div>
          
          <div className="footer-legal">
            <p className="body-small">
              {footer.legalText}
            </p>
          </div>

          <div className="footer-bottom">
            <p className="body-small text-secondary">
              © {currentYear} {name}. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
